// Skeleton - der eine Ladeplatzhalter fuer alle Seiten der App.
//
// Warum eine gemeinsame Komponente: Jede Seite laedt an anderer Stelle (Spaces, Pakete,
// Precheck-Stream, Git-Werte, Partner Directory ...), ein zentraler Schalter ist deshalb nicht
// moeglich. Was sich zentralisieren laesst, ist das Aussehen: Ton, Radius, Puls und die Regel,
// dass ein Skelett die SPAETERE Ansicht nachzeichnet (Karten-Raster, Tabellenzeilen, Textzeilen),
// damit beim Umschalten auf den Inhalt nichts springt. Der Puls ist die Pipeline-Animation
// (iio-skel-pulse), unter prefers-reduced-motion statisch.
//
// Anti-Flackern: Das Skelett blendet erst nach ~120 ms ein (CSS). Eine Antwort, die schneller
// da ist, zeigt gar kein Skelett - ein kurz aufblitzender Platzhalter wirkt unruhiger als gar
// keiner.
//
// Varianten:
//   cards  - Raster aus Karten (Kopfzeile + Zeilen), z. B. Space- oder Paketkacheln; das Raster
//            ist auto-fit wie die echten Kachel-Raster, columns=1 erzwingt volle Breite
//   rows   - Tabellen-/Listenzeilen mit mehreren Balken je Zeile
//   lines  - Textzeilen unterschiedlicher Breite (Absaetze, Details)
//   block  - eine Flaeche (Diagramm, Vorschau)
// Breiten sind aus dem Index abgeleitet (deterministisch): gleiche Props, gleiches Bild - auch
// in Tests und beim erneuten Rendern.
import React from "react";

const breite = (i, basis, spanne) => `${basis + ((i * 37) % spanne)}%`;

export default function Skeleton({ variant = "rows", count = 3, columns = 4, label, className = "", style }) {
  const n = Math.max(1, Math.min(Number(count) || 1, 12));
  const cols = Math.max(1, Math.min(Number(columns) || 1, 8));
  const items = Array.from({ length: n });
  const rootCls = `iio-skel iio-skel--${variant}${className ? ` ${className}` : ""}`;
  // role=status + aria-live: Screenreader erfahren, dass geladen wird; das sichtbare Label ist
  // optional (die Seite kann es schon ueber ihre Kopfzeile sagen).
  return (
    <div className={rootCls} role="status" aria-live="polite" aria-busy="true" style={style}>
      {label && <div className="iio-skel-label">{label}</div>}
      {variant === "cards" && (
        <div className={"iio-skel-grid" + (cols === 1 ? " iio-skel-grid--full" : "")}>
          {items.map((_, i) => (
            <div key={i} className="iio-skel-card">
              <div className="iio-skel-row"><i className="iio-skel-bar h" style={{ width: 18, height: 18 }} /><i className="iio-skel-bar h" style={{ width: breite(i, 40, 30) }} /></div>
              <div className="iio-skel-row"><i className="iio-skel-bar" style={{ width: breite(i + 1, 30, 30) }} /></div>
              <div className="iio-skel-row"><i className="iio-skel-bar" style={{ width: breite(i + 2, 20, 25) }} /><i className="iio-skel-bar" style={{ width: breite(i + 3, 15, 20) }} /></div>
            </div>
          ))}
        </div>
      )}
      {variant === "rows" && items.map((_, i) => (
        <div key={i} className="iio-skel-row iio-skel-row--table" style={{ animationDelay: `${i * 60}ms` }}>
          {Array.from({ length: cols }).map((__, c) => (
            <i key={c} className={"iio-skel-bar" + (c === 0 ? " h" : "")} style={{ width: breite(i + c, c === 0 ? 28 : 12, c === 0 ? 30 : 16) }} />
          ))}
        </div>
      ))}
      {variant === "lines" && items.map((_, i) => (
        <div key={i} className="iio-skel-row" style={{ animationDelay: `${i * 60}ms` }}>
          <i className="iio-skel-bar" style={{ width: breite(i, 55, 40) }} />
        </div>
      ))}
      {variant === "block" && <div className="iio-skel-block" />}
    </div>
  );
}
